import React from 'react';
import styled from 'styled-components';

import ReceiptLayout from '@/components/Receipt/ReceiptLayout';
import { DepartureCheck } from '@repo/components';
import { useAppSelector } from '@/hooks/useReduxHooks';
import { IGlobalState } from '@/store';
import { useHistory } from 'react-router-dom';
import { routes } from '@/constants/routes.const';

function DepartureCheckPage() {
  const { nationality } = useAppSelector((state) => state) as IGlobalState;
  const history = useHistory();
  const handleYes = () => {
    history.push(routes.airport);
    localStorage.setItem('departureCheck', 'yes');
  };
  const handleNo = () => {
    history.push(routes.selectAirport);
    localStorage.setItem('departureCheck', 'no');
  };

  return (
    <ReceiptLayout>
      <Wrapper>
        <DepartureCheck
          nationality={nationality}
          onYes={handleYes}
          onNo={handleNo}
        />
      </Wrapper>
    </ReceiptLayout>
  );
}

export default DepartureCheckPage;

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: 16px 0;
`;
